import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "radar-comparison" }
const _hoisted_2 = { class: "segmented-control-wrapper" }
const _hoisted_3 = { class: "segmented-control" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "selector-chips" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "chart-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Radar = _resolveComponent("Radar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasetOptions, (ds) => {
          return (_openBlock(), _createElementBlock("button", {
            key: ds.key,
            class: _normalizeClass(["segment", { active: _ctx.selectedDataset === ds.key }]),
            onClick: ($event: any) => (_ctx.selectedDataset = ds.key)
          }, _toDisplayString(ds.label), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allModels, (model) => {
        return (_openBlock(), _createElementBlock("button", {
          key: model.id,
          class: _normalizeClass(["selector-chip", { active: _ctx.isSelected(model.id) }]),
          onClick: ($event: any) => (_ctx.toggleModel(model.id))
        }, _toDisplayString(model.displayName), 11, _hoisted_6))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Radar, {
        data: _ctx.chartData,
        options: _ctx.chartOptions
      }, null, 8, ["data", "options"])
    ])
  ]))
}